<template>
  <div class="order-wrapper order-content payment-section">
    <portal target-el="#filter">
      <Breadcrumb
        back="Invoice"
        :title="invoice.invoice_number"
        :invoice="invoice"
        :loading="isLoading"
        :checkEditStatus="$invoice.canEditInvoice(invoice.status)"
        v-on:saveInvoice="saveInvoice"
        v-on:checked="checkedInvoice"
      />
    </portal>
    <div class="row no-margin">
      <div class="col-12 iftable no-rp wrappertable">
        <div class="new">
          <div class="table">
            <div v-if="isLoading">
              <Spinner />
            </div>
            <Table v-else :data="indentPayments" style="width: 100%" :max-height="windowHeight" aria-describedby="InvoiceDetailsData">
              <Table-Column fixed="left" label="INDENT ID" width="150">
                <template slot-scope="indent">
                  <Popover trigger="click" placement="bottom" popper-class="newpopover leftalign">
                    <div class="popover-primary">
                      <div class="popover-primary-header">
                        <!-- <h3>INDENT DETAILS</h3> -->
                        <div
                          class="vehtype"
                          v-if="indentDetails.vehicle_type"
                        >{{indentDetails.vehicle_type.name}}</div>
                        <!-- <span class="remove-icon" @click="quotes=false">
                          <svgicon name="cancelblack" width="12" height="12" :original="true" />
                        </span>-->
                      </div>
                      <div class="popover-primary-body">
                        <IndentDetails :indentDetails="indentDetails" />
                      </div>
                    </div>
                    <div
                      slot="reference"
                      class="name-wrapper"
                      @click="showIndentDetails(indent.row.order_id)"
                    >
                      <div class="temp-style">{{ indent.row.order_number }}</div>
                    </div>
                  </Popover>
                </template>
              </Table-Column>
              <Table-Column
                v-for="column in getColumns"
                :key="column.id"
                width="100"
                prop="column.column"
                :label="`${column.label}`"
              >
                <template slot-scope="payment">
                  <div class="table-td">
                    <Row
                      :column="column"
                      :rowIndex="payment.$index"
                      :payment="payment.row"
                      :invoiceStatus="invoice.status"
                      v-on:updateColumnAmount="updateColumnAmount"
                    />
                  </div>
                </template>
              </Table-Column>
              <Table-Column label="Documents" width="150">
                <template slot-scope="document">
                  <Popover placement="bottom" popper-class="newpopover">
                    <div class="popover-primary">
                      <div class="popover-primary-header">
                        <h3>DOCUMENTS</h3>
                        <!-- <span class="remove-icon" @click="attachment=false">
                    <svgicon name="cancelblack" width="12" height="12" :original="true" />
                        </span>-->
                      </div>
                      <div class="popover-primary-body">
                        <div class="docsection">
                          <div
                            class="docsection-list"
                            v-for="attach in document.row.attachments"
                            :key="attach._id"
                          >
                            <div class="docsection-textfile">
                              <svgicon name="imggallery" width="30" height="30" :original="true" />
                              <Ellipsis :text="attach.name" :length="20" />
                            </div>

                            <div class="docsection-action">
                              <a :href="attach.attachment_url" target="_blanks">
                                <svgicon name="download" width="12" height="12" :original="true" />Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div slot="reference" v-if="document.row.attachments.length" class="uploadtext">
                      <div class="success-style">Attachment</div>
                    </div>
                  </Popover>
                </template>
              </Table-Column>
              <Table-Column fixed="right" label="Total" width="150">
                <template slot-scope="invoice">
                  <div class="temp-style">
                    <Amount
                      :columnDetails="totalColumn"
                      :payment="invoice.row"
                      :invoiceStatus="invoice.status"
                      :isReadOnly="readonlyprop"
                    />
                  </div>
                </template>
              </Table-Column>
            </Table>
          </div>
        </div>
        <div class="col-12 table-footer table-footer-left" v-if="!isLoading && invoice">
          <div class="row align-items-center no-margin">
            <div class="col">
              <div class="titlesec">Total Indents : {{invoice.order_payments.length}}</div>
            </div>
            <div class="col-4">
              <ul class="table-footer-list">
                <li>
                  <div class="titlesec">Payable</div>
                </li>
                <li class="fltright">
                  <div class="titleprimary">{{$invoice.invoiceTotal(indentPayments, 'client')}}</div>
                </li>
              </ul>
              <ul class="table-footer-list">
                <li>
                  <div class="titlesec">Requested</div>
                </li>
                <li class="fltright">
                  <div class="titleprimary">{{$invoice.invoiceTotal(indentPayments, 'transporter')}}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-2 no-padding wrappertablegrey">
   <Comments />
      </div>-->
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { columns } from '@/constants/invoice';
import Breadcrumb from '../common/breadcrumb';
import IndentDetails from '../common/IndentDetails';
import Row from './row';
import Amount from './amount';

export default {
  components: {
    Breadcrumb,
    Row,
    Amount,
    IndentDetails,
  },
  data() {
    return {
      currentIndex: 0,
      columns,
      readonlyprop: true,
      attachment: true,
      totalColumn: {
        column: 'total_amount',
        compareBy: true,
      },
      indentDetails: [],
      showIndent: false,
    };
  },
  computed: {
    ...mapState('invoice', [
      'isLoading',
      'commentLoading',
      'comments',
      'invoice',
      'extractFirstPayment',
    ]),
    windowHeight() {
      return `${window.innerHeight - 250}px`;
    },
    indentPayments() {
      return this.invoice.order_payments
        .map(indent =>
          indent.charges.map(child =>
            Object.assign(
              {
                attachments: indent.attachments,
                order_number: indent.order_number,
                order_id: indent.order_id,
              },
              child,
            ),
          ),
        )
        .reduce((l, n) => l.concat(n), []);
    },
    getColumns() {
      const getHeaders = [...this.columns];
      if (this.$hasFeature('detention_combine_days')) {
        getHeaders.splice(4, true); // Removed  unloading detention
        getHeaders[3].label = 'Detention'; // Rename loading detention as Detention
      }
      return getHeaders;
    },
  },
  beforeMount() {
    this.$store.dispatch('invoice/find', this.$route.params);
  },
  methods: {
    showIndentDetails(orderId) {
      this.showIndent = true;
      this.indentDetails = this.invoice.order_payments.find(
        indent => indent.order_id === orderId,
      );
    },
    async checkedInvoice() {
      try {
        const result = await this.$store.dispatch('invoice/verify', {
          id: this.invoice.id,
        });
        if (result.id) {
          this.$success({
            message: `${this.invoice.invoice_number} ${this.$getSuccess(
              'INVOICE_CHECKED',
            )}`,
          });
        }
        if (result.error) {
          this.$error({
            message: result.error,
          });
        }
      } catch (e) {
        this.$error({
          message: `${this.$getErr('ACTION_ERR')}`,
        });
      }
    },
    async saveInvoice(showMessage = true) {
      try {
        const data = {};
        data.id = this.invoice.id;
        data.order_payments = this.invoice.order_payments.map((payment) => {
          const { id, charges } = payment;
          const consignemntCharges = charges.map(consignment => ({
            consignee_id: consignment.destination_location_id,
            contract_charge: consignment.contract_charge.client,
            lr_charge: consignment.lr_charge.client,
            oda_charges: consignment.oda_charges.client,
            unloading_charge: consignment.unloading_charge.client,
            loading_charge: consignment.loading_charge.client,
            extra_charges: consignment.extra_charges.client,
            additional_point_charges:
                consignment.additional_point_charges.client,
            arrival_charge: consignment.arrival_charge.client,
            loading_detention_charge:
                consignment.loading_detention_charge.client,
            leakage_charge: consignment.leakage_charge.client,
            shortage_charge: consignment.shortage_charge.client,
            damage_charge: consignment.damage_charge.client,
            carton_damage_charge: consignment.carton_damage_charge
              ? consignment.carton_damage_charge.client
              : 0,
            unloading_detention_charge:
                consignment.unloading_detention_charge.client,
            wallet_penalty_charge: consignment.wallet_penalty_charge
              ? consignment.wallet_penalty_charge.client
              : 0,
            transit_charge: consignment.transit_charge.client,
          }));
          return {
            id,
            charges: consignemntCharges,
          };
        });
        const result = await this.$store.dispatch('invoice/save', {
          id: this.invoice.id,
          data,
        });
        if (result.id && showMessage) {
          this.$success({
            message: `${this.$getSuccess('INVOICE_SAVED')}`,
          });
        }
        if (result.error && showMessage) {
          this.$error({
            message: result.error,
          });
        }
      } catch (e) {
        this.$error({
          message: `${this.$getErr('ACTION_ERR')}`,
        });
      }
    },
    updateColumnAmount(data) {
      const setRate = Number(data.value);
      const section = 'client';
      const orderNo = data.indentDetails.order_no || '';
      const consigneeId = data.indentDetails.consignee_id || '';
      const column = data.column;
      const indentIndex = this.invoice.order_payments.findIndex(
        indent => indent.order_number === orderNo,
      );
      if (indentIndex !== -1) {
        const consignments = this.invoice.order_payments[indentIndex].charges;
        const consIndex = consignments.findIndex(
          consignee => consignee.destination_location_id === consigneeId,
        );
        if (consIndex !== -1) {
          this.invoice.order_payments[indentIndex].charges[consIndex][column][
            section
          ] = setRate;
          this.invoice.order_payments[indentIndex].charges[consIndex].total_amount[section] = this.$invoice.total(consignments[consIndex]);
        }
      }
    },
  },
};
</script>


<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.uploadsection {
  .upload-demo {
    .el-upload {
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      &-dragger {
        width: 320px;
        height: 60px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 15px;
        .el-upload__text {
          line-height: 57px;
          color: #303030;
          font-size: 1.2rem;
          background: #fbfbfb;
        }
        .el-icon-upload {
          display: none;
          line-height: 1px;
        }
      }
    }
  }
  .actionbtn {
    text-align: right;
    padding: 20px 15px 10px 20px;
  }
}
.uploadtext {
    .success-style {
        padding: 0 20px;
        cursor: pointer;
        text-decoration: underline;
        color: #4B8E00;
        font-size: 1.2rem;
        font-family:$fontSemibold;
    }
    .temp-style {
        padding: 0 20px;
        cursor: pointer;
        text-decoration: underline;
    }
}
.docsection {
  padding: 20px 0 0;
  &-list {
    padding: 0 20px;
    display: flow-root;
    margin-bottom: 15px;
  }
  &-textfile {
    display: inline-block;
    float: left;
    .svg-icon {
      padding-right: 5px;
    }
    &-action {
        float: right;
        display: inline-block;
        a {
            color: #376F99;
            font-family:$fontBold;
            text-decoration: none;
        }
    }
  }
}

.leftalign {
  margin-left: 44px;
  margin-top: -8px !important;
  .popper__arrow {
    left: 24px !important;
  }
  .popover-primary {
    padding: 15px 0 0 0 !important;
  }
  .table-row {
    padding-left: 10px !important;
  }
  .tablepanel .new .table {
    border-bottom: 1px solid transparent;
  }
}

.vehtype {
    letter-spacing: 1px;
    color: #3a687d;
    font-family:$fontSemibold;
}
.name-wrapper {
  cursor: pointer;
}
.name-wrapper:hover {
  text-decoration: underline;
}
</style>
